// extracted by mini-css-extract-plugin
export var copyableField = "_rf-4";
export var customerBadge = "_rf-0";
export var customerInfoTitle = "_rf-2";
export var details = "_rf-1";
export var dropdownContainer = "_rf-5";
export var dropdownImage = "_rf-6";
export var editAssigneeForm = "_rf-a";
export var editButton = "_rf-3";
export var email = "_rf-7";
export var hidden = "_rf-d";
export var input = "_rf-8";
export var saveButton = "_rf-b";
export var shopifyIcon = "_rf-c";
export var suggestionBadge = "_rf-e";
export var suggestionText = "_rf-f";
export var username = "_rf-9";